import React from 'react';
import styles from './Process.module.css';

const Process = () => {
  const steps = [
    {
      number: 1,
      title: "Заполните форму с данными рождения",
      description: "Нажмите кнопку \"Заказать прогноз\" и заполните простую форму. Нам нужна дата рождения, время рождения (желательно точное), место рождения и ваш email."
    },
    {
      number: 2,
      title: "Оплатите $269 безопасным способом",
      description: "Мы принимаем банковские карты (Visa, MasterCard, МИР), электронные кошельки (ЮMoney, Qiwi), банковские переводы. Все платежи защищены."
    },
    {
      number: 3,
      title: "Получите прогноз через 21 день на email",
      description: "После оплаты мы начинаем персональный расчет вашего прогноза. Через 21 день на указанный email придет PDF-файл с вашим персональным прогнозом."
    }
  ];

  return (
    <section className={styles.process}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          Как получить ваш персональный прогноз:
          <br />
          <span className="gold-text"><span className={styles.downArrow}></span> 3 простых шага</span>
        </h2>
        <p className={styles.intro}>
          Заказать персональный прогноз проще, чем кажется. Всего 3 простых шага, и через 21 день вы получите детальный навигатор на весь 2026 год.
        </p>
        <div className={styles.steps}>
          {steps.map((step) => (
            <div key={step.number} className={styles.step}>
              <div className={styles.stepNumber}>{step.number}</div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDescription}>{step.description}</p>
            </div>
          ))}
        </div>
        <div className={styles.imageWrapper}>
          <img 
            src="https://strategy.annavision.me/wp-content/uploads/2025/12/c753c05f17eb882993a3f7901025970e_1766894518-1.png" 
            alt="Древняя магическая книга с огненной лошадью" 
            className={styles.bookImage}
          />
        </div>
      </div>
    </section>
  );
};

export default Process;

